<div class="d-flex flex-column h-100">
  <div class="px-2 h-45 border-bottom d-flex align-items-center justify-content-between">
    <div class="caption">
      {{ sidebarTitle }}
    </div>

    <i
      class="clickable remixicon-close-fill font-18 text-extra-muted"
      (click)="onCloseSidebar()"
      *ngIf="close | hasObservers"
    ></i>
  </div>

  <div class="overflow-auto perfect-scroll">
    <ng-container *ngIf="!editable">
      <ng-container *ngIf="activeTab === 'info'">
        <div class="py-1 px-2">
          <ng-container *ngLet="activeMap?.description | find: { field: 'i18n', filter: language } as description">
            <ng-container *ngIf="description?.value">
              <div class="map-info-section pt-2">
                <maplix-quill-view [content]="description.value" [sanitize]="true"></maplix-quill-view>
              </div>
            </ng-container>
          </ng-container>
        </div>
      </ng-container>
      <ng-container *ngIf="activeTab === 'basemap'">
        <div class="py-1 px-2">
          <maplix-grid-card
            [image]="'assets/images/map/' + base.id + '.png'"
            [type]="base.label"
            [typeHelp]="base.description"
            [size]="'md'"
            [isSelected]="mapForm.get('baseLayer')?.value === base.id"
            (action)="onSetBaseLayer(base.id)"
            *ngFor="let base of baseLayers"
          ></maplix-grid-card>
        </div>
      </ng-container>
      <ng-container *ngIf="activeTab === 'legend'">
        <div class="map-legend">
          <maplix-map-layers
            [dataLayers]="mapForm.get('dataLayers')"
            [wmsLegends]="wmsLegends"
            [language]="language"
            (toggleVisibility)="onChangeVisibility($event)"
          >
          </maplix-map-layers>
        </div>
      </ng-container>
      <ng-container *ngIf="activeTab === 'share'">
        <div class="py-2 px-2">
          <div class="form-group mb-2">
            <label class="form-label">{{ 'map.socials.url.LABEL' | translate }}</label>
            <div class="input-group">
              <input type="text" class="form-control" readonly disabled [ngModel]="mapUrl" />
              <div class="input-group-append">
                <button
                  class="btn btn-light form-control"
                  target="_blank"
                  [ngbTooltip]="'map.socials.url.COPYLABEL' | translate"
                  placement="left"
                  (click)="onCopyToClipboard(mapUrl)"
                >
                  <i class="fe-copy"></i>
                </button>
              </div>
            </div>
          </div>
          <div class="form-group mb-2">
            <label class="form-label">{{ 'map.socials.HEADER' | translate }}</label>
            <maplix-social-share-widget
              [entity]="'map'"
              [title]="(activeMap?.title | find: { field: 'i18n', filter: language }).value"
            ></maplix-social-share-widget>
          </div>
          <div class="form-group mb-2">
            <label class="form-label d-block">{{ 'map.socials.qr.LABEL' | translate }}</label>
            <img [src]="activeMap?.qr[this.language]?.black" height="200" />
          </div>
        </div>
      </ng-container>
    </ng-container>

    <ng-container *ngIf="editable && mapForm">
      <maplix-map-layers
        (toggleVisibility)="onChangeVisibility($event)"
        [dataLayers]="mapForm.get('dataLayers')"
        (changeLayerOrder)="onChangeLayerOrder()"
        [wmsLegends]="wmsLegends"
        [language]="language"
        (open)="onOpenLayerModal($event)"
        (openCloud)="onOpenCloudModal()"
        (toggleHidden)="onToggleHidden($event)"
        (onDelete)="onDeleteLayer($event)"
      >
      </maplix-map-layers>
    </ng-container>
  </div>
</div>
